var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8459 5.51785C3.18353 5.51785 2.60417 6.07765 2.60417 6.8213V16.7036C2.60417 17.4473 3.18352 18.0071 3.8459 18.0071H18.7815C19.4439 18.0071 20.0232 17.4473 20.0232 16.7036V6.8213C20.0232 6.07764 19.4439 5.51785 18.7815 5.51785H3.8459ZM0.820312 6.8213C0.820312 5.13923 2.15149 3.7326 3.8459 3.7326H18.7815C20.476 3.7326 21.8071 5.13924 21.8071 6.8213V16.7036C21.8071 18.3857 20.4759 19.7923 18.7815 19.7923H3.8459C2.1515 19.7923 0.820312 18.3857 0.820312 16.7036V6.8213Z",
    fill: "#29B170"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1128 12.1059C16.3343 12.1059 16.4714 11.9284 16.4714 11.7623C16.4714 11.5963 16.3343 11.4187 16.1128 11.4187C15.8914 11.4187 15.7543 11.5963 15.7543 11.7623C15.7543 11.9284 15.8914 12.1059 16.1128 12.1059ZM14.6875 11.7623C14.6875 10.9899 15.3023 10.3207 16.1128 10.3207C16.9234 10.3207 17.5382 10.9899 17.5382 11.7623C17.5382 12.5347 16.9234 13.204 16.1128 13.204C15.3023 13.204 14.6875 12.5347 14.6875 11.7623Z",
    fill: "#29B170"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7954 0.108683C16.7498 -0.427734 18.6066 1.09332 18.6066 3.09144V4.62516H16.8228V3.09144C16.8228 2.2038 16.0219 1.62323 15.2672 1.83036L3.53203 5.05127C2.99975 5.19737 2.60417 5.70447 2.60417 6.31236V6.82123H0.820312V6.31236C0.820312 4.93038 1.7245 3.69622 3.06022 3.3296L3.06023 3.3296L14.7954 0.108685L15.0313 0.969521L14.7954 0.108683Z",
    fill: "#29B170"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletGreen);
export default __webpack_public_path__ + "static/media/wallet_green.a09dde2db945383ecd6549ba02005350.svg";
export { ForwardRef as ReactComponent };